import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navItems, siteInfo } from '../data/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex flex-col items-start">
            <span className="text-white text-2xl font-bold tracking-[0.15em]" style={{ fontFamily: 'Georgia, serif' }}>
              GOC
            </span>
            <span className="text-white text-[9px] tracking-[0.25em] uppercase mt-0.5" style={{ fontFamily: 'Arial, sans-serif' }}>
              God of Cricket
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-14">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-white text-xs tracking-[0.2em] hover:text-gray-300 transition-colors duration-300 font-medium"
                style={{ fontFamily: 'Arial, sans-serif' }}
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* Hamburger Menu */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white hover:text-gray-300 transition-colors p-2"
          >
            <div className="flex flex-col space-y-1.5">
              <span className="w-7 h-[2px] bg-white"></span>
              <span className="w-7 h-[2px] bg-white"></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile/Full Screen Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black z-50">
          <div className="flex justify-end p-8">
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-white hover:text-gray-300 text-3xl font-light"
            >
              X
            </button>
          </div>
          <nav className="flex flex-col items-center justify-center h-full space-y-8 -mt-20">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white text-2xl tracking-[0.2em] hover:text-gray-300 transition-colors"
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
